//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import pdpComponentMixin from '~/mixins/pdpComponentMixin'

export default {
  mixins: [pdpComponentMixin],
  props: {
    activeTabIndex: { type: Number, required: true },
    lensTechSelected: { type: Boolean, required: true }
  },
  computed: {
    parts () {
      return this.sortedProductDetails.filter(
        ([part, partDetails]) => {
          // Hide parts that aren't in the active design unless conversion kit is enabled or we are in parts mode
          if (!this.conversionKitEnabled && !(part in this.design) && this.pageMode !== 'parts') return false

          // Hide slave parts (eg nose piece) unless this is a conversion kit
          if (this.pageMode !== 'conversionkit' && partDetails.slavePart) return false
          
          return true
        }
      ).map(([part, details]) => ({
        ...details,
        skuPrefix: part,
        icon: this.getIcon(details)
      }))
    }
  },
  watch: {
    parts (newParts, oldParts) {
      if (this.leMode) return false
      
      const expectedSkuPrefix = (oldParts[this.activeTabIndex] || {}).skuPrefix
      let newIndex = newParts.findIndex(part => part.skuPrefix === expectedSkuPrefix)
      if (newIndex === -1) newIndex = 0

      if (newIndex === this.activeTabIndex) return

      this.$emit('change-tab', newIndex, newParts[newIndex])
    }
  },
  mounted () {
    this.checkActivePart()
  },
  methods: {
    getIcon (partDetails) {
      const search = (partDetails.icon || '').match(/(sgi-[\w-]+)/i)
      return search ? search[0] : ''
    },
    checkActivePart () {
      if (!this.pageMode === 'parts' || this.leMode) return // Not in parts mode
      
      const expectedActivePart = Object.keys(this.design)[0]
      const activePart = (this.parts[this.activeTabIndex] || {}).skuPrefix
      
      if (activePart === expectedActivePart) return // Active part is correct

      const newIndex = this.parts.findIndex(part => part.skuPrefix === expectedActivePart)
      this.$emit('change-tab', newIndex, this.parts[newIndex])
    }
  }
}
